export default __webpack_public_path__ + "static/media/87.a720b7c2.png";